import { MwLoadOptions } from 'app/models/load-options.model';
import {
  TransportSiteApiModel,
  TransportSitesResponseModel,
} from 'app/models/transport-sites.model';
import { createAction, props } from '@ngrx/store';

export const loadTransportSites = createAction(
  '[TransportSites] Load',
  props<{ loadOptions?: MwLoadOptions }>()
);

export const loadTransportSitesSuccess = createAction(
  '[TransportSites] Load Successful',
  props<{ response: TransportSitesResponseModel }>()
);

export const loadTransportSitesFailure = createAction(
  '[TransportSites] Load Failure',
  props<{ error: any }>()
);

export const createTransportSite = createAction(
  '[TransportSites] Create',
  props<{ transportSite: TransportSiteApiModel }>()
);

export const createTransportSiteSuccess = createAction(
  '[TransportSites] Create Successful',
  props<{ transportSite: TransportSiteApiModel }>()
);

export const createTransportSiteFailure = createAction(
  '[TransportSites] Create Failure',
  props<{ error: any }>()
);

export const updateTransportSite = createAction(
  '[TransportSites] Update',
  props<{ transportSite: TransportSiteApiModel }>()
);

export const updateTransportSiteSuccess = createAction(
  '[TransportSites] Update Successful',
  props<{ transportSite: TransportSiteApiModel }>()
);

export const updateTransportSiteFailure = createAction(
  '[TransportSites] Update Failure',
  props<{ error: any }>()
);

export const deleteTransportSite = createAction(
  '[TransportSites] Delete',
  props<{ transportSite: TransportSiteApiModel }>()
);

export const deleteTransportSiteSuccess = createAction(
  '[TransportSites] Delete Successful'
);

export const deleteTransportSiteFailure = createAction(
  '[TransportSites] Delete Failure',
  props<{ error: any }>()
);
